import { environment } from '@bvl-admin/environments/environment';

export class FileEndpoint {

  public static image = `${environment.LOAD_BALANCER}/aws/s3/images/`;
  public static imageFilters = `${environment.LOAD_BALANCER}/aws/s3/images/filters`;
  public static imageDates = `${environment.LOAD_BALANCER}/aws/s3/images/dates`;
  public static imageMutable = `${environment.LOAD_BALANCER}/aws/s3/images/{id}`;

  public static video = `${environment.LOAD_BALANCER}/aws/s3/videos/`;
  public static videoFilters = `${environment.LOAD_BALANCER}/aws/s3/videos/filters`;
  public static videoDates = `${environment.LOAD_BALANCER}/aws/s3/videos/dates`;
  public static videoMutable = `${environment.LOAD_BALANCER}/aws/s3/videos/{id}`;

  public static documents = `${environment.LOAD_BALANCER}/aws/s3/documents/`;
  public static documentsFilters = `${environment.LOAD_BALANCER}/aws/s3/documents/filters`;
  public static documentsDates = `${environment.LOAD_BALANCER}/aws/s3/documents/dates`;
  public static documentsMutable = `${environment.LOAD_BALANCER}/aws/s3/documents/{id}`;

  public static icons = `${environment.LOAD_BALANCER}/aws/s3/icons/`;
  public static iconsFilters = `${environment.LOAD_BALANCER}/aws/s3/icons/filters`;
  public static iconsDates = `${environment.LOAD_BALANCER}/aws/s3/icons/dates`;
  public static iconsMutable = `${environment.LOAD_BALANCER}/aws/s3/icons/{id}`;

}
